import {
  GET_LABREQUESTREQ,
  GET_LABREQUESTREQ_FAIL,
  GET_LABREQUESTREQ_SUCCESS,
  GET_LABREQUESTREQS,
  GET_LABREQUESTREQS_FAIL,
  GET_LABREQUESTREQS_SUCCESS,
  ADD_NEW_LABREQUESTREQ,
  ADD_LABREQUESTREQ_SUCCESS,
  ADD_LABREQUESTREQ_FAIL,
  UPDATE_LABREQUESTREQ,
  UPDATE_LABREQUESTREQ_SUCCESS,
  UPDATE_LABREQUESTREQ_FAIL,
  DELETE_LABREQUESTREQ,
  DELETE_LABREQUESTREQ_SUCCESS,
  DELETE_LABREQUESTREQ_FAIL,
  SET_STATE_LABREQUESTREQ
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTREQ,
  payload: loading,
})

export const getLabRequestReqs = ( params ) => ({
  type: GET_LABREQUESTREQS,
  payload: { params },
})

export const getLabRequestReqsSuccess = (labRequestReqs, totalPages, currentPage) => ({
  type: GET_LABREQUESTREQS_SUCCESS,
  payload: { labRequestReqs:labRequestReqs, total:totalPages, currentPage:currentPage}
})

export const getLabRequestReqsFail = error => ({
  type: GET_LABREQUESTREQS_FAIL,
  payload: error,
})

export const addNewLabRequestReq = labRequestReq => ({
  type: ADD_NEW_LABREQUESTREQ,
  payload: labRequestReq,
})

export const addLabRequestReqSuccess = labRequestReq => ({
  type: ADD_LABREQUESTREQ_SUCCESS,
  payload: labRequestReq,
})  

export const addLabRequestReqFail = error => ({
  type: ADD_LABREQUESTREQ_FAIL,
  payload: error,
})

export const updateLabRequestReq = labRequestReq => ({
  type: UPDATE_LABREQUESTREQ,
  payload: labRequestReq,
})

export const updateLabRequestReqSuccess = labRequestReq => ({
  type: UPDATE_LABREQUESTREQ_SUCCESS,
  payload: labRequestReq,
})

export const updateLabRequestReqFail = error => ({
  type: UPDATE_LABREQUESTREQ_FAIL,
  payload: error,
})

export const deleteLabRequestReq = labRequestReq => ({
  type: DELETE_LABREQUESTREQ,
  payload: labRequestReq,
})

export const deleteLabRequestReqSuccess = id => ({
  type: DELETE_LABREQUESTREQ_SUCCESS,
  id,
})

export const deleteLabRequestReqFail = error => ({
  type: DELETE_LABREQUESTREQ_FAIL,
  payload: error,
})

export const getLabRequestReq = () => ({
  type: GET_LABREQUESTREQ,
})

export const getLabRequestReqSuccess = labRequestReq => ({
  type: GET_LABREQUESTREQ_SUCCESS,
  payload: labRequestReq,
})

export const getLabRequestReqFail = error => ({
  type: GET_LABREQUESTREQ_FAIL,
  payload: error,
})
